<template>
  <div class="split-button-component">
    <v-btn-toggle rounded v-show="!split" class="v-button-slit">
      <v-btn rounded @click.stop="click(button.button1)" class="first-button" min-width="85" max-height="38">
        <slot name="button1"></slot>
      </v-btn>
    </v-btn-toggle>
    <v-btn-toggle rounded v-show="split" class="v-button-slit">
      <v-btn @click.stop="click(button.button2)" class="action-button" min-width="42" max-height="38">
        <slot name="button2"></slot>
      </v-btn>
      <v-btn @click.stop="click(button.button3)" class="action-button" min-width="42" max-height="38">
        <slot name="button3"></slot>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>

import {computed} from '@vue/composition-api';

export default {
  name: "SplitButton",
  props: {
    value: Boolean
  },
  setup(props, {emit}) {
    const button = {
      button1: 1,
      button2: 2,
      button3: 3
    }

    const split = computed({
      get: () => props.value,
      set: (value) => {emit('input', value)}
    })

    function click(buttonClicked) {
      split.value = !split.value
      emit('click', buttonClicked)
    }

    return {click, split, button}
  }
}
</script>

<style scoped lang="scss">
.split-button-component {
  .v-button-slit.theme--light {
    > .v-btn {
      background-color: #ffffff;
      border: none;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
      margin: 0;

      &::before {
        opacity: 0 !important;
      }

      &:hover {
        color: #050505 !important;

        &::before {
          opacity: 0 !important;
        }
      }

      &.action-button {
        padding-left: 13px;
        padding-right: 9px;
        margin-right: 2px;

        + .action-button {
          padding-left: 9px;
          padding-right: 13px;
        }
      }
    }
  }
}
</style>

<!-- The following style have to be declared as global styles, otherwise they have no effect. -->
<style lang="scss">
.split-button-component {
  svg {
    .a {
      transition: all 0.2s ease-in-out;
    }
  }

  .v-button-slit.theme--light {
    > .v-btn {
      &.action-button {
        svg {
          width: 20px;
          height: 20px;
        }

        &:hover {
          svg {
            .a, .b {
              stroke: #73998E;
            }
          }
        }
      }
    }
  }
}
</style>
